function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null;

  try {
    const encoded = token.split('.')[1];
    if (!encoded) return null;
    const normalized = encoded.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

export function getAccessTokenPayload() {
  const token = localStorage.getItem('access_token') || localStorage.getItem('authToken');
  return decodeJwtPayload(token) ?? {};
}

export function getAccessTokenIdentity() {
  const payload = getAccessTokenPayload();

  return {
    userId: payload.userId ?? payload.user_id ?? payload.USER_ID,
    roleId: payload.roleId ?? payload.role_id ?? payload.ROLE_ID,
  };
}
